import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { cn } from '../../lib/utils';

export function Delta({
  value = 0,
  isPercent = true,
  lowerIsBetter = false,
  className = '',
  showIcon = true,
}) {
  const num = typeof value === 'number' ? value : parseFloat(value) || 0;
  const isZero = num === 0;
  const isPositive = num > 0;
  const isGood = lowerIsBetter ? !isPositive && !isZero : isPositive;

  const colorClasses = isZero
    ? 'text-zinc-500 bg-zinc-100 dark:bg-zinc-800 border-zinc-200 dark:border-zinc-700'
    : isGood
    ? 'text-emerald-700 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-950/40 border-emerald-200 dark:border-emerald-800/50'
    : 'text-red-700 dark:text-red-400 bg-red-50 dark:bg-red-950/40 border-red-200 dark:border-red-800/50';

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-semibold border tabular-nums',
        colorClasses,
        className
      )}
    >
      {showIcon && (
        isZero ? (
          <Minus className="w-3 h-3 shrink-0" />
        ) : isPositive ? (
          <TrendingUp className="w-3 h-3 shrink-0" />
        ) : (
          <TrendingDown className="w-3 h-3 shrink-0" />
        )
      )}
      <span>
        {isPositive ? '+' : ''}
        {num}
        {isPercent ? '%' : ''}
      </span>
    </span>
  );
}

export default Delta;
